import { GraphicalOutputPlaceholder } from '@datacamp/campus-integration';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Iframe = _ref => {
  let {
    source
  } = _ref;
  const {
    t
  } = useTranslation('translation', {
    keyPrefix: 'ExplorableExercise'
  });
  if (source === null) {
    return ___EmotionJSX(GraphicalOutputPlaceholder, null);
  }
  return ___EmotionJSX("div", {
    className: "dc-u-pos-relative dc-u-wh-100pc"
  }, ___EmotionJSX("iframe", {
    className: "dc-u-w-100pc dc-u-h-100pc dc-u-b-none",
    src: source,
    title: t('Iframe.title')
  }));
};
export default Iframe;